<template>
	<div id="newsPage" >

		<Header></Header>

		<div id="banner">

		</div>

		<div id="news">
			<div class="container">
				<div class="cate">
					<span>
						<router-link to="news.html">企业动态</router-link>
					</span>
					<span>
						<router-link to="/industryNews.html">行业新闻</router-link>
					</span>
					<span class="active">
						<router-link to="/commonSense.html">印刷常识</router-link>
					</span>
				</div>
				<ul>
					<li v-for="item in hyxw_news" :key="item.id">
						<router-link :to="'/news/detail-4-' + item.id + '.html'">
						  <div class="padding">

							<div class="txt">
							  <h2>{{ item.news_title }}</h2>
							  <p v-html="item.news_content"></p>
							  <!-- <div class="time">{{ item.news_display_date }}</div> -->
							</div>
						  </div>
						</router-link>
					</li>
				</ul>

        <div class="paging" v-show="isLoad">
          <Pagination :noPage="''" :pageInfo="pageInfo" @change="pagechange"></Pagination>
        </div>
			</div>
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../../components/Header.vue';
	import Footer from '../../components/Footer.vue';
  import Pagination from '../../components/Pagination';

  import { getHyxwNewsList } from '../../axios/api';

	export default {
    name: 'industry',
    data() {
      return {
        newsImgPrefix: process.env.PREFIX_IMG + 'news/',
        hyxw_news: [],
        pageInfo: {
          total: 100,
          current: this.$route.query.page ? (typeof(this.$route.query.page) === "object" ? 1 : Number(this.$route.query.page)) : 1,
          pagenum: 12,
          pagegroup: 3
        },
        isLoad: false,

        swiperOptionBig: {
          autoplay: 3000,
        }
      }
    },
		components: {
			Header,
			Footer,
      Pagination
		},

    mounted(){
      this.getNewsList({'pageNo': this.pageInfo.current, 'pageSize': this.pageInfo.pagenum, 'filter_params': {'news_category': '4', 'news_display': 1}})
	  $("#nav ul li:nth-child(4) a.parent").addClass("router-link-exact-active")
    },

    methods: {
      getNewsList(query) {
        getHyxwNewsList(query).then(response => {
          this.hyxw_news = response.data.data.list;
          this.pageInfo.total = response.data.data.total;

          this.isLoad = true;
        });
      },
      pagechange(current) {
        this.pageInfo.current = current;
        this.getNewsList({'pageNo': this.pageInfo.current, 'pageSize': this.pageInfo.pagenum, 'filter_params': {'news_category': '4', 'news_display': 1}})
      },
    },
	}
</script>

<style type="text/css" scoped>
	#news ul{
		min-height: 0;
		overflow: hidden;
	}
	.paging{
		text-align: center;
		margin-top: 20px;
	}
	.paging span{
		display: inline-block;
		width: 43px;
		height: 36px;
		background: #fff;
		text-align: center;
		line-height: 36px;
		font-size: 18px;
		color: #333333;
		margin: 0 3px;
	}
	.paging b{
		display: inline-block;
		width: 43px;
		height: 36px;
		background: #fff;
		text-align: center;
		line-height: 36px;
		font-size: 18px;
		color: #333333;
		margin: 0 3px;
	}
	.paging b img{
		position: relative;
		top: -2px;
	}
	.paging span:hover{
		background: #00a0e9;
	}
	.paging span:hover a{
		color: #fff;
	}
	.paging span a{
		color: #333333;
		display: block;
	}
	.paging span.active{
		background: #00a0e9;
	}
	.paging span.active a{
		color: #fff;
	}
	a{
		text-decoration: none;
	}
	#newsPage{
		background: #f4f4f4;
	}
	#banner{
		height: 412px;
		background: url('https://img.ds-cy.com/static/news_banner.jpg');
		background-position: top center;
	}
	#news{
		position: relative;
		top: -350px;
		min-height: 0;
		overflow: hidden;
		margin-bottom: -260px;
	}
	#news .cate{
		height: 55px;
		border-bottom: 1px solid rgba(255,255,255,.3);
		text-align: center;
		margin-bottom: 32px;
	}
	#news .cate span{
		font-size: 26px;
		color: #fff;
		margin: 0 30px;
		display: inline-block;
		height: 100%;
		position: relative;
	}
	#news .cate span a{
		color: inherit;
	}
	#news .cate span.active::after{
		position: absolute;
		    content: '';
		    height: 3px;
		    background: #00a0e9;
		    width: 100%;
		    bottom: 0;
		    left: 0;
	}
	#news ul li{
		width: 49%;
		float: left;
		background: #fff;
		margin-bottom: 24px;
	}
	#news ul li:nth-child(2n){
		float: right;
	}
	#news ul li .padding{
		padding: 28px 25px;
		min-height: 0;
		overflow: hidden;
	}
	#news ul li .img{
		float: left;
		margin-right: 25px;
		overflow: hidden;
	}
	#news ul li .img img{
		transition: all linear 200ms;
	}
	#news ul li .txt h2{
		font-size: 24px;
		color: #333333;
		line-height: 32px;
		height: 64px;
		margin-bottom: 12px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	#news ul li .txt .time{
		margin-top: 43px;
		color: #999999;
		font-size: 14px;
	}
	#news ul li .txt p{
		font-size: 14px;
		color: #808080;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		height: 42px;
	}
	#news ul li:hover img{
		transform: scale(1.1);
		-webkit-transform: scale(1.1);
	}

	#news ul li:hover h2{
		color: #00A0E9;
	}

	@media(max-width:767px){
		#news ul li .txt p{
			height: auto;
		}
		#news{
			top: 0;
			margin-bottom: 0;
			margin-top: 18px;
		}
		#banner{
			height: 120px;
			background-size: auto 120px;
		}
		#news .cate span{
			color: #333333;
			margin: 0 11px;
		}
		#news ul li{
			width: 100%;
			margin-bottom: 12px;
		}
		#news ul li .padding{
			padding: 15px;
		}
		#news ul li .img{
			width: 130px;
			margin-right: 12px;
		}
		#news ul li .img img{
			width: 100%;
		}
		#news ul li .txt h2{
			font-size: 16.5px;
			line-height: 23px;
			/* height: 20px; */
			margin-bottom: 9px;
			height: auto;
			/* white-space: nowrap; */
			overflow: hidden;
			text-overflow: ellipsis;
		}
		#news ul li .txt p{
			font-size: 12px;
			margin-bottom: 6px;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
			height: 40px;
			line-height: 20px;
		}
		#news ul li .txt .time{
			margin-top: 0;
			font-size: 13px;
		}
		#news .cate{
			border-bottom: 1px solid #ddd;
			height: 45px;
			margin-bottom: 20px;
		}
		#news .container{
			padding-left: 0;
			padding-right: 0;
		}
		#news ul{
			padding-left: 13px !important;
			padding-right: 13px !important;
		}
		#news .cate span{
			font-size: 19px;
		}
		#news .cate span.active{
			color: #00a0e9;
		}
		.paging b{
			width: 35px;
			height: 30px;
			line-height: 30px;
		}
		.paging span{
			width: 35px;
			height: 30px;
			line-height: 30px;
			font-size: 16px;
			margin: 0;
		}
		.paging b img{
		    top: -1px;
		    width: 13px;
		}
		.paging{
			margin-top: 0;
			margin-bottom: 0px;
		}
		#news .cate span.active::after{
			height: 2px;
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/news/common-sense.html.vue